// Workflow Controller Top Level Config
import {
    ref,
    watch
} from "vue"
import {
    useWorkflowNav
} from "@/../../library/compFunctions/useWorkflowNav.js"
import {
    useWorkflowPanels
} from "@/../../library/compFunctions/useWorkflowPanels.js"

export function useWorkflowController() {
    // Configure the entire workflow view
    const {
        config: config,
        mode: wMode
    } = useWorkflowNav()
    const {
        mode: panelMode,
        hero: hero,
        search: search,
        main: main
    } = useWorkflowPanels()

    // Get the mode of the workflow
    let mode = ref(null)

    // React to changes in mode
    watch(mode, () => {
        wMode.value = mode.value
        panelMode.value = mode.value
    })

    return {
        mode,
        config,
        hero,
        search,
        main
    }

}